class Comment {
  //obj并非 ret ，而是ret.data
  constructor(obj = {}) {
    this.sonComment = {}
    this.id = obj.id || ''
    this.subject_id = obj.subject_id || ''
    this.comment = obj.comment || ''
    this.re_type = obj.re_type  || ''
    this.type = obj.type || ''
    this.group = obj.group || ''
    this.is_against = (obj.group == -1)

    this.com_id = obj.com_id || ''
    this.status = obj.status || ''
    this.follow = obj.follow || 0   //评论赞数
    this.is_follow = obj.is_follow || 0 //用户是否点赞
    this.created_at = obj.created_at || ''
    this.user = this.setCommentUser(obj)
    this.comment2 = this.setComment2(obj)
    //console.log(this)
  }

  setCommentUser(obj){
    let head_image = jdw.initImage(obj.info.head)
    obj.info.head = head_image
    return obj.info;
  }

  setComment2(obj){
    var comment = obj.comment;
    var regExp = new RegExp(obj.answerStr,'ig');
    if (obj.comment.indexOf(obj.answerStr) != '-1'){
      comment = obj.comment.replace(regExp,'********');
    }else{
      comment = obj.comment;
    }
    return comment;
  }
}
jdw.classes.Comment = Comment
//导出本地类
export default Comment